import { Accordion, AccordionDetails, AccordionSummary } from '@mui/material'
import styled, { css } from 'styled-components'

export const Root = styled(Accordion)`
  border-radius: 12px !important;
  border: 1px solid var(--t-template-border);
  box-shadow: none !important;
  overflow: hidden;

  &::before {
    display: none;
  }

  & + & {
    margin-top: 0;
  }

  &.Mui-expanded {
    margin: 0 !important;
  }
`

export const Summary = styled(AccordionSummary)`
  min-height: 80px !important;
  padding: 16px !important;
  gap: 24px;
  background-color: var(--t-base-expandable-card-bg) !important;

  flex-direction: ${({ $iconPosition }) =>
    $iconPosition === 'left' ? 'row-reverse' : 'row'};

  gap: ${({ $iconGap }) => `${$iconGap}px`};

  ${({ $variant }) =>
    $variant === 'template' &&
    css`
      background-color: var(
        --t-base-expandable-card-template-page-bg
      ) !important;
    `}

  &.Mui-expanded {
    min-height: 64px !important;
  }

  .MuiAccordionSummary-content {
    margin: 0 !important;
    align-items: center;
  }

  .MuiAccordionSummary-content.Mui-expanded {
    margin: 0 !important;
  }

  .MuiAccordionSummary-expandIconWrapper {
    width: 36px;
    height: 36px;
    display: flex;
    align-items: center;
    justify-content: center;

    svg {
      color: var(--t-description-templates-hint-close-button-color);
    }
  }
`

export const Details = styled(AccordionDetails)`
  padding: 0 16px 16px !important;
  background-color: var(--t-base-expandable-card-bg) !important;
  color: var(--t-text-primary);

  ${({ $variant }) =>
    $variant === 'template' &&
    css`
      background-color: var(
        --t-base-expandable-card-template-page-bg
      ) !important;
    `}
`
